import { __rest, __assign } from '../../../node_modules/tslib/tslib.es6.js';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import classNames from 'classnames';
import SvgDown16 from '../../../icons/interface/Down16.js';
import SvgRemove16 from '../../../icons/interface/Remove16.js';
import { c as components } from '../../../node_modules/react-select/dist/index-a7690a33.esm.js';

// react-select internal component replacements
// ------------------------------------------------------------------
// Chip / Multi Value
// add color classes to chip, see chip-options.js for options array examples
var MultiValueContainer = function (_a) {
    var innerProps = _a.innerProps, props = __rest(_a, ["innerProps"]);
    var _b = props.data, _c = _b.color, color = _c === void 0 ? 'neutral' : _c, variant = _b.variant;
    innerProps.className = classNames('chip', variant ? "chip-".concat(variant, "-").concat(color) : "chip-".concat(color));
    return jsx(components.MultiValueContainer, __assign({}, props, { innerProps: innerProps }));
};
// add icon to chip label
var MultiValueLabel = function (_a) {
    var children = _a.children, innerProps = _a.innerProps, props = __rest(_a, ["children", "innerProps"]);
    var _b = props.data, Icon = _b.Icon, color = _b.color, variant = _b.variant, darkIcon = _b.darkIcon;
    innerProps.className = 'chip-label';
    // neutral icon color override for default and bordered chips
    var iconClasses = classNames('chip-icon-prefix', {
        'text-default': variant !== 'solid' && (color === 'neutral' || darkIcon)
    });
    return (jsxs(Fragment, { children: [Icon && jsx(Icon, { className: iconClasses }), jsx(components.MultiValueLabel, __assign({}, props, { innerProps: innerProps }, { children: children }))] }));
};
// replace X icon for chip
var MultiValueRemove = function (_a) {
    var innerProps = _a.innerProps, props = __rest(_a, ["innerProps"]);
    innerProps.className = 'btn-close-inline chip-remove rounded-circle';
    return (jsx(components.MultiValueRemove, __assign({}, props, { innerProps: innerProps }, { children: jsx(SvgRemove16, {}) })));
};
// ------------------------------------------------------------------
// replace clear indicator X icon
var ClearIndicator = function (props) { return (jsx(components.ClearIndicator, __assign({}, props, { children: jsx(SvgRemove16, { style: { width: '20px', height: '20px' } }) }))); };
// replace clear indicator X icon
var DropdownIndicator = function (props) { return (jsx(components.DropdownIndicator, __assign({}, props, { children: jsx(SvgDown16, { style: { width: '20px', height: '20px' } }) }))); };
var ReactSelectOverrides = {
    MultiValueContainer: MultiValueContainer,
    MultiValueLabel: MultiValueLabel,
    MultiValueRemove: MultiValueRemove,
    ClearIndicator: ClearIndicator,
    DropdownIndicator: DropdownIndicator
};
var NoIndicatorSeparator = function () { return jsx(Fragment, {}); };

export { ClearIndicator, DropdownIndicator, MultiValueContainer, MultiValueLabel, MultiValueRemove, NoIndicatorSeparator, ReactSelectOverrides as default };
